export const getPricingIdxFromUserPlan = (userPlan) => {
    if (userPlan === null){
        return 0
    } else {
        return userPlan
    }

    return null
}